import { client } from "./supabase";

export const getPlanPagosEdificios = async (pais) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .select("*, edificio:edificios(id, edificio)")
    .eq("pais", pais)
    .eq("estado", "pendiente")
    .order("fecha_acordada");
  if (error) throw error;
  return data || [];
};

export const crearPlanPagoEdificio = async ({ edificio_id, pais, monto, fecha_acordada, nota, created_by }) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .insert([{ edificio_id, pais, monto, fecha_acordada, nota, created_by, estado: "pendiente" }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const actualizarPlanPagoEdificio = async (id, cambios) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .update({ ...cambios })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const marcarPlanPagoEdificioPagado = async (id, movimiento_caja_id) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .update({ estado: "pagado", movimiento_caja_id })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const anularPlanPagoEdificio = async (id) => {
  const { error } = await client.from("plan_pagos_edificios").update({ estado: "anulado" }).eq("id", id);
  if (error) throw error;
};
